import { Component, ChangeDetectionStrategy } from '@angular/core';
import { InputComponent } from '../input/input.component';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SliderComponent extends InputComponent {

}
